export default {
  monogastric: {
    name: 'monogastric',
    title: 'Monogastric',
    images: {
      '1x': process.env.BASE_URL + '/img/monogastric.png',
      '2x': process.env.BASE_URL + '/img/monogastric@2x.png',
    },
  },
  ruminant: {
    name: 'ruminant',
    title: 'Ruminant',
    images: {
      '1x': process.env.BASE_URL + '/img/ruminant.png',
      '2x': process.env.BASE_URL + '/img/ruminant@2x.png',
    },
  },
};
